/* hs-eslint ignored failing-rules */
/* eslint-disable promise/catch-or-return */
/* eslint-disable prefer-promise-reject-errors */
import { Component, useEffect } from 'react';
import { connect } from 'react-redux';
import emptyFunction from 'react-utils/emptyFunction';
import memoizeOne from 'react-utils/memoizeOne';
import I18n from 'I18n';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { isMigrationFailed } from 'knowledge-content-types/KnowledgeBaseV3Service/MigrationTypes';
import ArticleNotFound from '../../components/insights/articlePerformance/ArticleNotFound';
import RequestStatus from '../../constants/edit/RequestStatus';
import { prePublishArticle, publishArticle } from '../../actions/article/PublishArticleActions';
import { updateArticle } from '../../actions/article/UpdateArticleActions';
import { clearArticleEditInfoState, getArticleEditInfo } from '../../actions/edit/ArticleEditInfoActions';
import { getCategoryOrganization } from '../../actions/edit/CategoryActions';
import { createMultiLanguageCategory, getMultiLanguageCategories } from '../../actions/edit/MultiLanguageCategoryActions';
import { closeTranslateTemplateModal, openTranslateTemplateModal } from '../../actions/TemplateEditorActions';
import { updateArticleVisibilityBasedOnPublishStatus } from '../../actions/ArticleVisibilityActions';
import { getDisabledInteractionsConfig } from '../../actions/DisabledInteractionsConfigActions';
import { getImportedArticleNeedsReview, reviewImportedArticle } from '../../actions/ImportArticlesActions';
import { getTemplateSettings } from '../../actions/TemplateSettingsBufferActions';
import { WRITE_STEP } from '../../constants/edit/StepsConstants';
import { ERROR_CODES } from '../../constants/ApiErrorConstants';
import { visibilityOptions } from '../../constants/ArticleVisibilityConstants';
import StateConstants from '../../constants/StateConstants';
import { EMPTY_STRING } from '../../constants/SharedConstants';
import { SCREENS } from '../../constants/TrackingConstants';
import { isFetched, wasJustFetched } from '../../utils/ajaxUtils';
import { DEFAULT_ARTICLE_NAME } from '../../utils/articleUtils';
import { getArticlePayload, getInitialVisibilityParams, getVisibilityParamsFromArticle, hasNoSelectedListsError, areSelectedListsEqual } from '../../utils/articleVisibilityUtils';
import { getSelectedCategory, getSelectedSubCategory, slugify } from '../../utils/categorizeUtils';
import * as GatesUtils from '../../utils/gatesUtils';
import { isDomainNotConnectedError as getIsDomainNotConnectedError } from '../../utils/publishArticleError';
import UsageTracker from '../../utils/UsageTracker';
import EditPageTinyMCE from './EditPageTinyMCE';
import { push } from '../../actions/HistoryActions';
import { getIsEditorReadOnly } from '../../reducers/edit/articleContentInfo';
import { addArticleToMultiLangGroup, detachArticleFromMultiLangGroup } from '../../actions/edit/MultiLanguageArticleActions';
import { selectSiteSettingsFetched } from '../../selectors/siteSettings';
import { getPublishedArticlePath } from '../../routing/utils/internalPaths';
import { selectCurrentKbMigrationReport, selectMembershipSsoEnabledForDomain } from '../../knowledge-base/selectors/knowledgeBaseDetails';
import StageKnowledgeBase from '../StageKnowledgeBase';
import { useGetKnowledgeBaseLimitOverage } from '../../knowledge-base/hooks/knowledgeBaseHooks';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { getSettingUrl } from '../../routing/utils/externalUrls';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useAppSelector } from '../../utils/hooks';
import { Link } from 'foundations-components/transitional/components/Link';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class EditTinyMCE extends Component {
  constructor(...args) {
    super(...args);
    this.state = Object.assign({}, getInitialVisibilityParams(), {
      articleSaveStatus: RequestStatus.UNINITIALIZED,
      summary: EMPTY_STRING,
      name: EMPTY_STRING,
      language: EMPTY_STRING,
      path: EMPTY_STRING,
      isDomainNotConnectedError: false,
      selectedCategory: undefined,
      selectedStep: WRITE_STEP,
      selectedSubcategory: undefined,
      headHtml: EMPTY_STRING,
      metaDescription: EMPTY_STRING
    });
    this.session = new Date().valueOf();
    this.handleBeforeUnload = () => {
      const {
        articleContentInfo: {
          hasLocalChanges
        }
      } = this.props;
      return hasLocalChanges ? I18n.text('knowledgeContentUI.edit.beforeUnloadWarning') : null;
    };
    this.handleUpdateSaveStatus = newStatus => {
      const {
        articleSaveStatus
      } = this.state;
      if (articleSaveStatus !== newStatus && newStatus !== RequestStatus.UNINITIALIZED) {
        this.setState({
          articleSaveStatus: newStatus
        });
      }
    };
    this.handleCategoryChange = categoryId => {
      const {
        articleContentInfo: {
          article
        },
        categoryOrganizationInfo: {
          categories
        }
      } = this.props;
      const {
        selectedCategory: prevSelectedCategory,
        selectedSubcategory: prevSelectedSubcategory
      } = this.state;
      const selectedCategory = getSelectedCategory(categoryId, categories);
      const selectedSubcategory = getSelectedSubCategory(categoryId, selectedCategory);
      this.setState({
        selectedCategory,
        selectedSubcategory
      });
      this.props.updateArticle(article, {
        values: {
          hs_knowledge_category_id: categoryId
        }
      });
      if (prevSelectedCategory !== selectedCategory) {
        UsageTracker.track('createArticleInteraction', {
          screen: SCREENS.CREATE,
          subscreen: 'categorize',
          action: 'selected-category'
        });
      }
      if (prevSelectedSubcategory !== selectedSubcategory) {
        UsageTracker.track('createArticleInteraction', {
          screen: SCREENS.CREATE,
          subscreen: 'categorize',
          action: 'selected-subcategory'
        });
      }
    };
    this.handleKnowledgeBaseChange = newKnowledgeBaseId => {
      const {
        articleContentInfo: {
          article
        }
      } = this.props;
      this.setState({
        selectedCategory: undefined,
        selectedSubcategory: undefined
      });
      const data = {
        values: {
          hs_knowledge_category_id: null,
          hs_group_id: newKnowledgeBaseId
        }
      };
      const translatedLanguages = Object.keys(article.translations);
      const allLanguages = [article.values.hs_language, ...translatedLanguages];
      this.props.updateArticle(article, data);
      this.props.getMultiLanguageCategories({
        languages: allLanguages,
        knowledgeBaseId: newKnowledgeBaseId
      });
    };
    this.handleCreateMultiLangCategory = (translations, parentCategoryId, language) => {
      const {
        articleContentInfo: {
          article
        },
        knowledgeBase
      } = this.props;
      this.props.createMultiLanguageCategory(translations, parentCategoryId, knowledgeBase.id).then(({
        payload: {
          id
        }
      }) => {
        this.props.getMultiLanguageCategories({
          languages: [language],
          knowledgeBaseId: article.values.hs_group_id
        }).then(() => {
          this.props.updateArticle(article, {
            values: {
              hs_knowledge_category_id: id
            }
          });
        });
      });
    };
    this.handleTagsChange = tagIds => {
      const {
        articleContentInfo: {
          article
        }
      } = this.props;
      this.props.updateArticle(article, {
        values: {
          hs_tag_ids: tagIds
        }
      });
    };
    this.handleLanguageChange = language => {
      const {
        articleContentInfo: {
          article
        }
      } = this.props;
      this.props.updateArticle(article, {
        values: {
          hs_language: language
        }
      });
    };
    this.handleHeadHtmlChange = headHtml => {
      this.setState({
        headHtml
      });
    };
    this.handleHeadHtmlSave = () => {
      const {
        articleContentInfo: {
          article
        }
      } = this.props;
      const {
        headHtml
      } = this.state;
      if (article.values.hs_head_html !== headHtml) {
        this.props.updateArticle(article, {
          values: {
            hs_head_html: headHtml
          }
        });
        UsageTracker.track('createArticleInteraction', {
          screen: SCREENS.CREATE,
          subscreen: 'categorize',
          action: 'changed-head-html'
        });
      }
    };
    this.handleAddToGroup = masterArticle => {
      const {
        articleContentInfo: {
          article
        }
      } = this.props;
      this.props.addArticleToMultiLangGroup(article, masterArticle);
    };
    this.handleRemoveFromGroup = () => {
      const {
        articleContentInfo: {
          article
        }
      } = this.props;
      this.props.detachArticleFromMultiLangGroup(article);
    };
    this.handlePublishArticle = () => {
      const {
        articleContentInfo: {
          article: {
            values: {
              hs_id: id,
              hs_state: state
            }
          }
        },
        importedArticleNeedsReview: {
          needsReview
        }
      } = this.props;
      const action = state && state === StateConstants.PUBLISHED ? 'updated' : 'published';
      const publishingSteps = [this.props.publishArticle(id)];
      if (needsReview) {
        publishingSteps.push(this.props.reviewImportedArticle(id));
      }
      Promise.all(publishingSteps).then(() => {
        this.props.routeChange(getPublishedArticlePath(id));
        UsageTracker.track('publishedOrUpdatedArticle', {
          screen: SCREENS.CREATE,
          subscreen: this.state.selectedStep,
          action,
          visibility: this.state.selectedVisibility === visibilityOptions.RESTRICTED ? 'lists' : 'public'
        });
      }, emptyFunction);
      if (state !== StateConstants.PUBLISHED) {
        UsageTracker.track('createArticleInteraction', {
          screen: SCREENS.CREATE,
          subscreen: this.state.selectedStep,
          action: 'publish-article-click'
        });
      } else {
        UsageTracker.track('createArticleInteraction', {
          screen: SCREENS.CREATE,
          subscreen: this.state.selectedStep,
          action: 'update-article-click'
        });
      }
    };
    this.handleCategoryTranslationSuccess = () => {
      const {
        articleContentInfo: {
          article
        },
        articleContentInfo: {
          article: {
            values: {
              hs_knowledge_category_id: knowledgeCategoryId
            }
          }
        }
      } = this.props;
      const data = {
        values: Object.assign({}, article.values, {
          hs_knowledge_category_id: knowledgeCategoryId
        })
      };
      this.props.updateArticle(article, data);
    };
    this.handleCustomSlugEndingUpdate = ({
      target: {
        value
      }
    }) => {
      this.setState({
        path: value
      });
      UsageTracker.track('createArticleInteraction', {
        screen: SCREENS.CREATE,
        subscreen: 'categorize',
        action: 'changed-url'
      });
    };
    this.handleCustomSlugEndingSave = () => {
      const {
        articleContentInfo: {
          article
        }
      } = this.props;
      const {
        path
      } = this.state;
      this.setState({
        path: slugify(path)
      });
      if (path) {
        return this.props.updateArticle(article, {
          values: {
            hs_slug: path
          }
        });
      }
      return Promise.reject();
    };
    this.handleTitleChange = e => {
      const title = e.target.value || DEFAULT_ARTICLE_NAME;
      const {
        articleContentInfo: {
          article
        }
      } = this.props;
      this.setState({
        name: title
      });
      if (article.values.hs_slug) {
        this.props.updateArticle(article, {
          values: {
            hs_name: title
          }
        });
      }
    };
    this.handleTitleBlur = () => {
      const title = this.state.name || DEFAULT_ARTICLE_NAME;
      const {
        articleContentInfo: {
          article
        }
      } = this.props;
      if (!article.values.hs_slug) {
        this.props.updateArticle(article, {
          values: {
            hs_name: title
          }
        });
      }
    };
    this.handleHtmlTitleChange = ({
      target: {
        value: htmlTitle
      }
    }) => {
      this.setState({
        name: htmlTitle
      });
    };
    this.handleHtmlTitleSave = () => {
      const {
        articleContentInfo: {
          article
        }
      } = this.props;
      const {
        name
      } = this.state;
      if (article.values.hs_name !== name) {
        this.props.updateArticle(article, {
          values: {
            hs_name: name
          }
        });
        UsageTracker.track('createArticleInteraction', {
          screen: SCREENS.CREATE,
          subscreen: 'categorize',
          action: 'changed-page-title'
        });
      }
    };
    this.handleSubtitleChange = e => {
      const subtitle = e.target.value;
      const {
        articleContentInfo: {
          article
        }
      } = this.props;
      this.setState({
        summary: subtitle
      });
      if (article.values.hs_summary !== subtitle) {
        this.props.updateArticle(article, {
          values: {
            hs_summary: subtitle
          }
        });
      }
    };
    this.handleStepChange = selectedStep => {
      this.setState({
        selectedStep
      });
      UsageTracker.track('pageView', {
        screen: SCREENS.CREATE,
        subscreen: selectedStep
      });
    };
    this.handleVisibilityChange = selectedVisibility => {
      const {
        articleContentInfo: {
          article
        }
      } = this.props;
      this.setState(() => {
        if (selectedVisibility === visibilityOptions.PUBLIC) {
          return {
            selectedLists: [],
            selectedVisibility
          };
        }
        return {
          selectedVisibility,
          selectedLists: this.state.selectedLists
        };
      }, () => this.handleUpdateArticleVisibility(article, this.state.selectedLists, selectedVisibility));
    };
    this.handleSelectedListsChange = ({
      target
    }, isOpen) => {
      const {
        value: nextSelectedLists
      } = target;
      const {
        articleContentInfo: {
          article
        }
      } = this.props;
      const {
        selectedLists,
        selectedVisibility
      } = this.state;
      this.setState({
        selectedLists: nextSelectedLists
      }, () => {
        // Updates article visibility even when removing lists and the select is closed
        if (!isOpen && selectedLists.length > nextSelectedLists.length) this.handleUpdateArticleVisibility(article, nextSelectedLists, selectedVisibility);
      });
    };
    this.handleSelectedListsClose = selectedLists => {
      const {
        articleContentInfo: {
          article
        }
      } = this.props;
      const {
        selectedVisibility
      } = this.state;
      this.setState({
        selectedLists
      }, () => this.handleUpdateArticleVisibility(article, selectedLists, selectedVisibility));
    };
    this.handleUpdateArticleVisibility = (article, selectedLists, selectedVisibility) => {
      if (!hasNoSelectedListsError({
        selectedLists,
        selectedVisibility
      })) {
        this.props.updateArticleVisibilityBasedOnPublishStatus(article, getArticlePayload({
          selectedLists,
          selectedVisibility
        })).catch(error => {
          throw error;
        });
      }
    };
    this.handleMetaDescriptionChange = e => {
      const metaDescription = e.target.value;
      this.setState({
        metaDescription
      });
    };
    this.handleMetaDescriptionSave = () => {
      const {
        articleContentInfo: {
          article
        }
      } = this.props;
      const {
        metaDescription
      } = this.state;
      if (article.values.hs_meta_description !== metaDescription) {
        this.props.updateArticle(article, {
          values: {
            hs_meta_description: metaDescription
          }
        });
        UsageTracker.track('createArticleInteraction', {
          screen: SCREENS.CREATE,
          subscreen: 'categorize',
          action: 'changed-meta-description'
        });
      }
    };
    this.memoizedAreSelectedListsEqual = memoizeOne(areSelectedListsEqual);
  }
  componentDidMount() {
    const {
      articleContentInfo: {
        article: {
          values: {
            hs_summary: articleSummary,
            hs_name: name,
            hs_group_id: knowledgeBaseId
          }
        }
      },
      disabledInteractionsConfig,
      urlParams: {
        articleId
      }
    } = this.props;
    this.props.clearArticleEditInfoState();
    this.props.getArticleEditInfo(articleId);
    this.props.getImportedArticleNeedsReview(articleId);
    if (knowledgeBaseId) {
      this.props.getTemplateSettings(knowledgeBaseId);
    }
    if (!disabledInteractionsConfig.isRequesting && disabledInteractionsConfig.lastLoaded === undefined) {
      this.props.getDisabledInteractionsConfig();
    }
    if (name) {
      this.setState({
        name
      });
    }
    if (articleSummary) {
      this.setState({
        summary: articleSummary
      });
    }
    UsageTracker.track('pageView', {
      screen: SCREENS.CREATE,
      subscreen: this.state.selectedStep
    });
    window.onbeforeunload = this.handleBeforeUnload;
  }
  componentDidUpdate(prevProps) {
    const {
      articleContentInfo: {
        article,
        article: {
          values: {
            hs_knowledge_category_id: knowledgeCategoryId,
            hs_head_html: headHtml,
            hs_meta_description: metaDescription,
            hs_name: name,
            hs_summary: summary,
            hs_slug: path,
            hs_language: language,
            hs_group_id: knowledgeBaseId
          },
          translations
        },
        error,
        isUpdating,
        isUpdated
      },
      articleContentInfo,
      categoryOrganizationInfo: {
        categories
      },
      urlParams: {
        articleId
      }
    } = this.props;
    const {
      articleContentInfo: {
        article: prevArticle,
        article: {
          values: {
            hs_head_html: prevHeadHtml,
            hs_meta_description: prevMetaDescription,
            hs_language: prevLanguage,
            hs_slug: prevPath,
            hs_group_id: prevKnowledgeBaseId
          }
        },
        error: prevError,
        isUpdating: prevIsUpdating,
        isUpdated: prevIsUpdated
      },
      articleContentInfo: prevArticleContentInfo,
      categoryOrganizationInfo: {
        categories: prevCategories
      },
      urlParams: {
        articleId: prevArticleId
      }
    } = prevProps;
    if (articleId && prevArticleId && prevArticleId !== articleId) {
      this.props.clearArticleEditInfoState();
      this.props.getArticleEditInfo(articleId);
      this.props.getImportedArticleNeedsReview(articleId);
    }
    if (knowledgeBaseId && knowledgeBaseId !== prevKnowledgeBaseId) {
      this.props.getTemplateSettings(knowledgeBaseId);
      this.setState({
        name
      });
      this.setState({
        summary
      });
    }
    if (knowledgeBaseId && prevLanguage !== language && translations) {
      const translatedLanguages = Object.keys(translations);
      const allLanguages = [language, ...translatedLanguages];
      this.props.getMultiLanguageCategories({
        languages: allLanguages,
        knowledgeBaseId
      });
    }
    if (prevIsUpdating !== isUpdating || prevIsUpdated !== isUpdated || prevError !== error) {
      let isDomainNotConnectedError = false;
      if (error !== undefined) {
        if (getIsDomainNotConnectedError(error)) {
          this.handleUpdateSaveStatus(RequestStatus.SUCCEEDED);
          isDomainNotConnectedError = true;
        } else {
          this.handleUpdateSaveStatus(RequestStatus.FAILED);
        }
      } else if (isUpdating) {
        this.handleUpdateSaveStatus(RequestStatus.PENDING);
      } else if (isUpdated) {
        this.handleUpdateSaveStatus(RequestStatus.SUCCEEDED);
      }
      this.setState({
        isDomainNotConnectedError
      });
    }
    if (this.state.selectedCategory === undefined || !prevCategories.equals(categories)) {
      const selectedCategory = getSelectedCategory(knowledgeCategoryId, categories);
      const selectedSubcategory = getSelectedSubCategory(knowledgeCategoryId, selectedCategory);
      if (selectedCategory !== this.state.selectedCategory) {
        this.setState({
          selectedCategory,
          selectedSubcategory
        });
      }
    }
    if (path && prevPath !== path) {
      this.setState({
        path
      });
    }
    if (headHtml && prevHeadHtml !== headHtml) {
      this.setState({
        headHtml
      });
    }
    if (metaDescription && prevMetaDescription !== metaDescription) {
      this.setState({
        metaDescription
      });
    }
    if (wasJustFetched(prevArticleContentInfo, articleContentInfo)) {
      this.setState({
        name: article.values.hs_name,
        summary: article.values.hs_summary
      });
      if (this.props.siteSettingsFetched) {
        this.setVisibilityParams(article);
      }
    } else if (!!article.values.hs_translated_from_id && article.values.hs_translated_from_id !== prevArticle.values.hs_translated_from_id) {
      this.setVisibilityParams(article);
    }
    if (this.props.siteSettingsFetched && !prevProps.siteSettingsFetched && isFetched(articleContentInfo)) {
      this.setVisibilityParams(article);
    }
  }
  componentWillUnmount() {
    window.onbeforeunload = null;
  }
  setVisibilityParams(article) {
    const {
      membershipSsoEnabled
    } = this.props;
    const {
      knowledgeBase: {
        isKnowledgeBasePrivate
      }
    } = this.props;
    const visibilityParams = getVisibilityParamsFromArticle(article);
    if (membershipSsoEnabled && article.values.hs_access_rule_ids && article.values.hs_access_rule_ids.length === 0 && isKnowledgeBasePrivate) {
      visibilityParams.selectedVisibility = visibilityOptions.SSO;
      this.setState(visibilityParams);
      this.handleUpdateArticleVisibility(article, [], visibilityOptions.SSO);
    } else {
      this.setState(visibilityParams);
    }
  }

  // @ts-expect-error ts-migrate(7031) FIXME: Binding element 'htmlTitle' implicitly has an 'any... Remove this comment to see the full error message

  render() {
    const {
      articleContentInfo: {
        article,
        article: {
          values: {
            hs_knowledge_category_id: knowledgeCategoryId
          }
        },
        error,
        hasBufferedChanges,
        hasLocalChanges,
        isPrePublishing,
        isPublishing
      },
      categoryOrganizationInfo,
      disabledInteractionsConfig: {
        isPublishArticleTemporarilyDisabled
      },
      importedArticleNeedsReview,
      knowledgeBase,
      knowledgeScopes,
      readOnly,
      routeChange,
      templateSettings,
      translateTemplateModal
    } = this.props;
    const {
      articleSaveStatus,
      summary,
      name,
      path,
      isDomainNotConnectedError,
      originalSelectedLists,
      selectedCategory,
      selectedLists,
      selectedStep,
      selectedSubcategory,
      selectedVisibility,
      headHtml,
      metaDescription
    } = this.state;
    if (error && error.status === ERROR_CODES.NOT_FOUND) {
      return /*#__PURE__*/_jsx(ArticleNotFound, {
        onRouteChange: routeChange
      });
    }
    if (article.values.hs_id === undefined) {
      return /*#__PURE__*/_jsx(TFlex, {
        justify: "center",
        children: /*#__PURE__*/_jsx(LoadingSpinner, {
          size: "medium",
          use: "success",
          marginBlock: "1500",
          marginInline: "auto"
        })
      });
    }
    const showPublishingOverlay = isPrePublishing || isPublishing;
    const selectedCategoryId = knowledgeCategoryId || undefined;
    return /*#__PURE__*/_jsx(StageKnowledgeBase, {
      knowledgeBaseId: article.values.hs_group_id,
      children: /*#__PURE__*/_jsx(EditPageTinyMCE, {
        articleBufferError: error ? error.responseJSON : {},
        article: article,
        articleSaveStatus: articleSaveStatus,
        articleSubtitle: summary,
        articleTitle: name,
        articleHtmlTitle: name,
        categoryOrganizationInfo: categoryOrganizationInfo,
        closeTranslateTemplateModal: this.props.closeTranslateTemplateModal,
        customSlugEnding: path,
        hasBufferedChanges: hasBufferedChanges,
        hasLocalChanges: hasLocalChanges,
        headHtml: headHtml,
        importedArticleNeedsReview: importedArticleNeedsReview,
        isDomainNotConnectedError: isDomainNotConnectedError,
        isPublishArticleTemporarilyDisabled: isPublishArticleTemporarilyDisabled,
        isUngatedForSeoKbTitle: this.props.isUngatedForSeoKbTitle,
        knowledgeBase: knowledgeBase,
        knowledgeScopes: knowledgeScopes,
        listsDetail: this.props.listsDetail,
        multiLangCategories: this.props.multiLangCategories,
        metaDescription: metaDescription,
        openTranslateTemplateModal: this.props.openTranslateTemplateModal,
        onAddToGroup: this.handleAddToGroup,
        onArticleSubtitleChange: this.handleSubtitleChange,
        onArticleTitleBlur: this.handleTitleBlur,
        onArticleTitleChange: this.handleTitleChange,
        onArticleHtmlTitleSave: this.handleHtmlTitleSave,
        onArticleHtmlTitleChange: this.handleHtmlTitleChange,
        onCategoryChange: this.handleCategoryChange,
        onCategoryTranslationSuccess: this.handleCategoryTranslationSuccess,
        onCreateMultiLangCategory: this.handleCreateMultiLangCategory,
        onHeadHtmlChange: this.handleHeadHtmlChange,
        onHeadHtmlSave: this.handleHeadHtmlSave,
        onLanguageChange: this.handleLanguageChange,
        onMetaDescriptionChange: this.handleMetaDescriptionChange,
        onMetaDescriptionSave: this.handleMetaDescriptionSave,
        onPrePublishArticle: this.props.prePublishArticle,
        onPublishArticle: this.handlePublishArticle,
        onRemoveFromGroup: this.handleRemoveFromGroup,
        onRouteChange: routeChange,
        onCustomSlugEndingSave: this.handleCustomSlugEndingSave,
        onCustomSlugEndingUpdate: this.handleCustomSlugEndingUpdate,
        onSelectedListsChange: this.handleSelectedListsChange,
        onSelectedListsClose: this.handleSelectedListsClose,
        onStepChange: this.handleStepChange,
        onTagsChange: this.handleTagsChange,
        onVisibilityChange: this.handleVisibilityChange,
        onKnowledgeBaseChange: this.handleKnowledgeBaseChange,
        readOnly: readOnly,
        showPublishingOverlay: showPublishingOverlay,
        selectedCategory: selectedCategory,
        selectedCategoryId: selectedCategoryId,
        selectedLists: selectedLists,
        selectedListsHaveChanged: !this.memoizedAreSelectedListsEqual(originalSelectedLists, selectedLists),
        selectedStep: selectedStep,
        selectedSubcategory: selectedSubcategory,
        selectedVisibility: selectedVisibility,
        templateSettings: templateSettings,
        translateTemplateModal: translateTemplateModal,
        migrationReport: this.props.migrationReport
      })
    });
  }
}
const mapStateToProps = (state, ownProps) => {
  const {
    auth,
    articleContentInfo,
    categoryOrganizationInfo,
    disabledInteractionsConfig,
    importedArticleNeedsReview,
    knowledgeBaseDetails: {
      knowledgeBase
    },
    knowledgeScopes,
    listsDetail,
    multiLangCategories,
    templateSettings,
    translateTemplateModal
  } = state;
  return {
    articleContentInfo,
    categoryOrganizationInfo,
    disabledInteractionsConfig,
    importedArticleNeedsReview,
    isUngatedForSeoKbTitle: GatesUtils.isUngatedForSeoKbTitle(auth.gates),
    knowledgeBase,
    knowledgeScopes,
    listsDetail,
    membershipSsoEnabled: selectMembershipSsoEnabledForDomain(state),
    multiLangCategories,
    siteSettingsFetched: selectSiteSettingsFetched(state),
    templateSettings,
    translateTemplateModal,
    urlParams: ownProps.match.params
  };
};
const mapDispatchToProps = {
  addArticleToMultiLangGroup,
  closeTranslateTemplateModal,
  clearArticleEditInfoState,
  createMultiLanguageCategory,
  detachArticleFromMultiLangGroup,
  getArticleEditInfo,
  getCategoryOrganization,
  getMultiLanguageCategories,
  getDisabledInteractionsConfig,
  getImportedArticleNeedsReview,
  getTemplateSettings,
  openTranslateTemplateModal,
  prePublishArticle,
  publishArticle,
  reviewImportedArticle,
  routeChange: push,
  updateArticle,
  updateArticleVisibilityBasedOnPublishStatus
};
const ConnectedEditTinyMCE = connect(mapStateToProps, mapDispatchToProps)(EditTinyMCE);
const EditTinyMCEHookWrapper = props => {
  const kbMigrationReport = useAppSelector(selectCurrentKbMigrationReport);
  const editorReadOnly = useAppSelector(state => getIsEditorReadOnly(state.articleContentInfo) || kbMigrationReport && !isMigrationFailed(kbMigrationReport === null || kbMigrationReport === void 0 ? void 0 : kbMigrationReport.migration.status));
  const {
    isOverLimit,
    overageCount
  } = useGetKnowledgeBaseLimitOverage();
  useEffect(() => {
    if (isOverLimit) {
      FloatingAlertStore.addAlert({
        id: 'downgrade-alert',
        message: /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(Text, {
            as: "p",
            marginBlockEnd: "0",
            children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
              message: "knowledgeContentUI.downgradeBanner.description_jsx",
              elements: {
                UILink: Link
              },
              options: {
                href: getSettingUrl(),
                count: overageCount
              }
            })
          }), /*#__PURE__*/_jsx(FormattedJSXMessage, {
            message: "knowledgeContentUI.downgradeBanner.downgradesLink_jsx",
            elements: {
              UILink: Link
            },
            options: {
              href: 'https://knowledge.hubspot.com/account/downgrade-a-paid-subscription',
              external: true
            }
          })]
        }),
        sticky: true,
        titleText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "knowledgeContentUI.downgradeBanner.title"
        }),
        type: 'danger'
      });
    }
  }, [isOverLimit, overageCount]);
  return /*#__PURE__*/_jsx(ConnectedEditTinyMCE, Object.assign({}, props, {
    readOnly: editorReadOnly || isOverLimit,
    migrationReport: kbMigrationReport === null || kbMigrationReport === void 0 ? void 0 : kbMigrationReport.migration
  }));
};
export default EditTinyMCEHookWrapper;